import React from "react";
import DefaultUsers from "src/components/feature/Users";

const Users = () => {
  return <DefaultUsers />;
};

export default Users;
